import { render, staticRenderFns } from "./RegisteredHotels.vue?vue&type=template&id=e3e992c8&scoped=true"
import script from "./RegisteredHotels.vue?vue&type=script&lang=js"
export * from "./RegisteredHotels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e992c8",
  null
  
)

export default component.exports